<template>
  <div class="container">
    <span class="title is-3">{{ empresa.nombrec }}</span>
    <small class="title is-5"
      >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
    >
    <small class="subtitle is-7">{{ empresa.nombre }}</small>
    <hr />
    <div>
      <p class="title">Mes Comercial: {{ empresa.mesc | periodo }}</p>
    </div>
    <div class="subtitle is-5" style="margin-top: 16px">
      <span>
        Este es el mes en el cual está trabajando el sistema comercial. Al pasar
        de mes es como si se cerrara el mes.
        <strong
          >Sólo se puede regresar al mes anterior si en el mes actual no hay
          registros.</strong
        >
      </span>
    </div>
    <div class="field has-addons">
      <p class="control">
        <button class="button is-link is-large" @click="lastMonth">
          <span class="icon">
            <span class="material-icons">keyboard_arrow_left</span>
          </span>
        </button>
      </p>
      <p class="control">
        <button class="button is-large">
          <span>{{ empresa.mesc | periodo }}</span>
        </button>
      </p>
      <p class="control">
        <button class="button is-link is-large" @click="nextMonth">
          <span class="icon">
            <span class="material-icons">keyboard_arrow_right</span>
          </span>
        </button>
      </p>
    </div>
    <br>
    <h1 class="title is-4">Lista de Periodos</h1>
    <table class="table">
      <thead>
        <tr>
          <th>Periodo</th>
          <th>Año</th>
          <th>Mes</th>
          <th>Estatus</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in months" :key="index">
          <td>{{ item.codigo }}</td>
          <td>{{ item.year }}</td>
          <td>{{ item.mes }}</td>
          <td>{{ item.abierto ? "Abierto." : "Cerrado." }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      months: [],
    };
  },
  computed: {
    ...mapState(["empresa", "nits"]),
  },
  methods: {
    async nextMonth() {
      try {
        const result = await apiServices.get(`/changemonthnext`);
        if (result.data) {
          this.$store.commit("refreshEmpresa", result.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async lastMonth() {
      try {
        const result = await apiServices.get(`/changemonthlast`);
        if (result.data && result.data.message) {
          this.$store.dispatch("notify", {
            message: `${result.data.message}`,
            type: "is-danger",
            position: "top-center",
          });
        } else if (result.data) {
          this.$store.commit("refreshEmpresa", result.data);
        }
      } catch (err) {
        console.log(err);
      }
    },
    async findMonths() {
      try {
        const result = await apiServices.get(`/meses`);
        if (result.data) {
          this.months = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.findMonths();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/configurations/commercialmonth/Commertialmonth.vue